import { render, staticRenderFns } from "./RecordtableConcepts.vue?vue&type=template&id=ba0a1b40&"
import script from "./RecordtableConcepts.vue?vue&type=script&lang=js&"
export * from "./RecordtableConcepts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports